import { Team } from '#utils/teams/records/Team';

export function isTeamType(t: unknown): t is Team {
  return t instanceof Team;
}
